import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import TalkToTheBookV1 from '../views/TalkToTheBookV1.vue'
import TalkToTheBookV2 from '../views/TalkToTheBookV2.vue'
import SharedResponse from '@/views/SharedResponse.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'TalkToTheBook',
    meta: { title: 'Talk to the Books_AI閱讀精靈歐叩比' },

    component: TalkToTheBookV1,
  },
  {
    path: '/tttbV2',
    name: 'TalkToTheBookV2',
    meta: { title: 'Talk to the Books_AI閱讀精靈歐叩比' },

    component: TalkToTheBookV2,
  },
  {
    path: '/share/:shareId',
    name: 'SharedResponse',
    meta: { title: 'Talk to the Books_AI閱讀精靈歐叩比' },

    component: SharedResponse,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta?.title as string || 'Talk to the Books_AI閱讀精靈歐叩比';

  if (to.path.startsWith('/share/')) {
    next();
    return;
  }

  const referrer = document.referrer;
  const allowedDomains = [
    'taaze.tw',
    'www.taaze.tw',
    'https://taaze.tw',
    'https://www.taaze.tw',
    'talk.taaze.tw',
    'www.talk.taaze.tw',
    'https://talk.taaze.tw',
    'https://www.talk.taaze.tw',
  ];

  const isAllowed = allowedDomains.some(domain => referrer.includes(domain));

  if (isAllowed || process.env.VUE_APP_DEBUG === 'true') {
    next();
  } else {
    window.location.href = 'https://taaze.tw';
  }
});

export default router;
